import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<DEditor @value={{this.value}} @change={{this.valueChanged}} />",{ moduleName: "discourse/components/reviewable-field-editor.hbs" })